import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AppSection from '@/pages/home/components/AppSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <UpdatesSection />
        <MediaSection />
        <CardsSection />
        <FeaturesSection />
        <CommentsSection />
        <IndexSection />
        <RankingSection />
        <AppSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}